import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-minus-red",
  "use": "icon-minus-red-usage",
  "viewBox": "0 0 10 2",
  "content": "<symbol viewBox=\"0 0 10 2\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-minus-red\">\n<path d=\"M5.5 0.5H9C9.27333 0.5 9.5 0.726667 9.5 1C9.5 1.27333 9.27333 1.5 9 1.5H5.5H4.5H1C0.726667 1.5 0.5 1.27333 0.5 1C0.5 0.726667 0.726667 0.5 1 0.5H4.5H5.5Z\" fill=\"#E83550\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol